/**
 * VENDOR MODULES
 */
import React from 'react';

import { getMarketTypeByGroupId } from 'shared/utils/markets';
import OutcomeImages              from 'shared/components/outcomes/OutcomeImages';
import Winners                    from 'features/markets/components/singles/Winners';
import Place                      from 'features/markets/components/singles/Place';
import Show                       from 'features/markets/components/singles/Show';

// Custom CSS to override blue backgrounds and fix text color
const customStyles = `
  .singles-wrapper .competitor-code,
  .singles-wrapper .competitor-name,
  .singles-wrapper .outcome-name {
    background-color: transparent !important;
    background: none !important;
    color: #374151 !important;
  }
  
  /* Override all SCSS blue backgrounds */
  .competitor-name,
  .outcome-name,
  .competitor-code {
    background-color: transparent !important;
    background: none !important;
    color: #374151 !important;
  }
`;

function SingleMarkets(props) {
  const {
      sport_id = 0,
      n_runners = 0,
      runners: runnersProp = [],
      outcomes: outcomesProp = {},
      event_id = 0,
  } = props;

  const wMarket = getMarketTypeByGroupId(501, props);
  const pMarket = getMarketTypeByGroupId(502, props);
  const sMarket = getMarketTypeByGroupId(503, props);
  const w_mk_id = wMarket?.market_type_id;
  const p_mk_id = pMarket?.market_type_id;
  const s_mk_id = sMarket?.market_type_id;

  const outcomesList = Array.isArray(outcomesProp) ? outcomesProp : (outcomesProp && typeof outcomesProp === 'object' ? Object.values(outcomesProp) : []);
  const getOutcomeForRunner = (marketTypeId, runnerNumber, runnerId) => {
    if (!marketTypeId) return null;
    const mtid = String(marketTypeId);
    const rn = runnerNumber != null ? String(runnerNumber) : null;
    const rid = runnerId != null ? String(runnerId) : null;
    // Racing singles outcomes are encoded by runner position (1..n) in the payload.
    // Some legacy payloads used runner_id: try runner number first, then runner_id.
    return (
      outcomesList.find((o) => String(o?.market_type_id) === mtid && rn != null && String(o?.outcome) === rn) ||
      outcomesList.find((o) => String(o?.market_type_id) === mtid && rid != null && String(o?.outcome) === rid) ||
      null
    );
  };

  // Check if Show market is supported.
  // IMPORTANT: runner payload does not always include a runner number (only runner_id),
  // while singles outcomes are encoded as 1..n codes. So infer support from outcomes.
  const showMarketSupported = !!(
    s_mk_id &&
    outcomesList.some((o) => String(o?.market_type_id) === String(s_mk_id) && o?.odd != null)
  );

  const runners = runnersProp;
  if (!Array.isArray(runners) || !runners.length) {
    return (
      <>
        <style>{customStyles}</style>
        <div className="p-4 text-sm text-muted-foreground">No runners available.</div>
      </>
    );
  }

  const single_market_outcomes = runners
    .filter((runner) => runner?.runner_id != null)
    .map((runner, i) => {
    const runnerId = runner.runner_id;
    // Runner icons are keyed by runner position (1..n), not by runner_id.
    // Our payload runner_id is an internal id (e.g. 27), so derive a stable display number.
    const runnerNumber =
      runner?.runner_number ??
      runner?.number ??
      runner?.runnerNo ??
      (i + 1);
    const winnerOutcomeObj = getOutcomeForRunner(w_mk_id, runnerNumber, runnerId);
    const placeOutcomeObj = getOutcomeForRunner(p_mk_id, runnerNumber, runnerId);
    const showOutcomeObj = getOutcomeForRunner(s_mk_id, runnerNumber, runnerId);
    const isEvenRow = i % 2 === 1; // Even row numbers (2nd, 4th, 6th, etc.)
    return (
      <div className={`flex flex-row items-center w-full border-b border-border py-2 ${isEvenRow ? 'bg-muted' : 'bg-background'}`} key={i}>
        <div className="grid-item w-1/12 flex items-center justify-center">
          <div className="competitor-code" style={{backgroundColor: 'transparent !important', background: 'none !important'}}>
            <OutcomeImages {...{outcome: runnerNumber, n_runners: n_runners, sport_id: sport_id, br: 0}}/>
          </div>
        </div>
        <div className="grid-item w-4/12 px-2">
          <div className="competitor-name text-sm font-medium truncate" style={{backgroundColor: 'transparent !important', background: 'none !important'}}><span>{runner?.name || `#${runnerId}`}</span></div>
        </div>
        <Winners {...{...(winnerOutcomeObj || { outcome: String(runnerNumber) }), market_type_id: w_mk_id, event_id: event_id, event: props}}/>
        <Place {...{...(placeOutcomeObj || { outcome: String(runnerNumber) }), market_type_id: p_mk_id, event_id: event_id, event: props}}/>
        {showMarketSupported && (
          <Show {...{...(showOutcomeObj || { outcome: String(runnerNumber) }), market_type_id: s_mk_id, event_id: event_id, event: props}}/>
        )}
      </div>
    );
  });

  return (
    <>
      <style>{customStyles}</style>
      <div className="singles-wrapper flex flex-col w-full">
        {single_market_outcomes}
      </div>
    </>
  );
}

export default SingleMarkets;

